import type { FC } from 'react';
import StudioHeaderMobile from '../../StudioHeaderMobile';
import LayoutContainer from '../../StudioTableMobile/_partials/LayoutContainer';
import ShopTabs from '../../products/ShopTabs';
import ProductsLobbyPageContent from '../../products/ProductsLobbyPageContent';
import { useSelector } from 'react-redux';
import { getActiveSection } from '../../../selectors/studio';
import { StudioSection } from '../../../types/store';
import SellerDiscountsMobile from '../SellerDiscounts/SellerDiscountsMobile';
import SellerDiscountsAll from '../SellerDiscounts/SellerDiscountsAll';
import ReportsSectionMobile from '../../reports/ReportsSection/ReportsSectionMobile';
import EarningsPageContent from '../../earnings/EarningsPageContent';

interface Props {}

const ShopPageContentMobile: FC<Props> = () => {
  const activeSection = useSelector(getActiveSection);

  const renderContent = () => {
    switch (activeSection) {
      case StudioSection.PRODUCTS_LOBBY:
        return <ProductsLobbyPageContent />;
      case StudioSection.SELLER_DISCOUNTS_ACTIVE_AND_SCHEDULED:
      case StudioSection.SELLER_DISCOUNTS_ENDED:
        return <SellerDiscountsMobile />;
      case StudioSection.SELLER_DISCOUNTS_ALL:
        return <SellerDiscountsAll />;
      case StudioSection.SHOP_REPORTS:
        return <ReportsSectionMobile />;
      case StudioSection.EARNINGS:
        return <EarningsPageContent />;
      default:
        return null;
    }
  };

  return (
    <LayoutContainer>
      <StudioHeaderMobile />
      <ShopTabs />
      {renderContent()}
    </LayoutContainer>
  );
};
ShopPageContentMobile.displayName = 'ShopPageContentMobile';

export default ShopPageContentMobile;
